/* eslint-disable no-shadow */
import { FormFields, FormValidationSchema } from '../../common/interfaces';

export enum HostingFormInputs {
  Name = 'name',
  Link = 'link'
}

export type HostingsFormFields = FormFields<typeof HostingFormInputs>;

export type HostingFormValidationSchema = FormValidationSchema<HostingsFormFields>;

export enum HostingAccountFormInputs {
  Login = 'login',
  Password = 'password'
}

export type HostingAccountFormFields = FormFields<typeof HostingAccountFormInputs>;

export type HostingAccountFormValidationSchema = FormValidationSchema<HostingAccountFormFields>;
